import PromisedPayment from './PromisedPayment'
import Sagas from 'modules/Finance/PromisedPayment/store/saga'
import Reducer from 'modules/Finance/PromisedPayment/store/reducer'

export default PromisedPayment

export { Sagas, Reducer }
